import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";

import { fetchGraphQL } from 'services/graphql/GraphQL';

import UserDucks from "stores/ducks/User.duck";

interface IDashboardOverviewProps {
  isLoggedIn?: boolean;
}

/**
 * When the "/" route is accessed.
 */
class LandingPage extends React.Component<IDashboardOverviewProps> {
  public render() {
    // custom url redirect first
    const url = window.location.href.toLowerCase();
    // console.log(url)
    const urlItems = url.split('/')
    const subdomain = urlItems[2].split('.')[0]

    if (subdomain !== 'platform' && subdomain !== 'test' && subdomain !== 'localhost:3000') {
      fetchGraphQL(`
      query {
        url {
          getLinkBySubdomain(subdomain:"${subdomain}") 
        }
      }
      `).then(res => {
        if (res && res.url && res.url.getLinkBySubdomain) {
          window.location.href = 'https://platform.isotopeticketing.com' + res.url.getLinkBySubdomain
        }
      })
    } else if (this.props.isLoggedIn === true) {
      window.location.pathname = '/manage/events';
      // window.location.reload();
      return null;
    } else {
      return <Redirect to="/login" />;
    }
  }
}

const mapStateToProps = state => {
  return {
    isLoggedIn: UserDucks.isAuthenticated(state)
  };
};
export default connect(mapStateToProps)(LandingPage);



// WEBPACK FOOTER //
// ./src/pages/Landing.page.tsx